import { render, staticRenderFns } from "./EditStoryPage.vue?vue&type=template&id=3c85c165&scoped=true"
import script from "./EditStoryPage.vue?vue&type=script&lang=js"
export * from "./EditStoryPage.vue?vue&type=script&lang=js"
import style0 from "./EditStoryPage.vue?vue&type=style&index=0&id=3c85c165&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c85c165",
  null
  
)

export default component.exports